/**
 * Review data for the Testimonials section.
 * Add new entries here to show more reviews.
 * Use translation keys for date, title, text (sr/en in locales).
 */
export const reviews = [
  {
    id: '1',
    name: 'Nikola Petrović',
    image: 'https://i.pravatar.cc/120?img=12',
    dateKey: 'reviews.date1',
    titleKey: 'reviews.title1',
    textKey: 'reviews.text1',
    rating: 5,
  },
  {
    id: '2',
    name: 'Jovana Marković',
    image: 'https://i.pravatar.cc/120?img=23',
    dateKey: 'reviews.date2',
    titleKey: 'reviews.title2',
    textKey: 'reviews.text2',
    rating: 5,
  },
  {
    id: '3',
    name: 'Ana Stojanović',
    image: 'https://i.pravatar.cc/120?img=32',
    dateKey: 'reviews.date3',
    titleKey: 'reviews.title3',
    textKey: 'reviews.text3',
    rating: 5,
  },
  {
    id: '4',
    name: 'Stefan Ristić',
    image: 'https://i.pravatar.cc/120?img=33',
    dateKey: 'reviews.date4',
    titleKey: 'reviews.title4',
    textKey: 'reviews.text4',
    rating: 5,
  },
];
